<template>
  <div class="navBar">
    <span class="title">关于我们</span>
    <ul>
      <li class="barMain" 
          v-for="item in list" 
          :key="item.id"
          :class="active === item.id ? 'active' : ''"
          @click="handleClickLi(item)"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'aboutNavBar',
  data() {
    return {
      list: [
        {
          id: 1,
          title: '公司介绍',
          routeName: 'pageCompany'
        },
        {
          id: 2,
          title: '联系我们',
          routeName: 'pageContact'
        },
        {
          id: 3,
          title: '实体站展示',
          routeName: 'pageEntity'
        },
        {
          id: 4,
          title: '组织机构',
          routeName: 'pageStructure'
        },
        {
          id: 5,
          title: '分公司办事处',
          routeName: 'pageFiliale'
        }
      ],
      active: 1
    }
  },
  methods: {
    handleClickLi(item) {
      this.active = item.id
      this.$emit('navBarClick', item.routeName)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>